import { Trend } from './trend';

export const TRENDS: Trend[] = [
  {
    title: 'Network',
    icon: 'fa fa-handshake-o',
    image: '',
    description: '',
  }, {
    title: 'Technologies',
    icon: 'fa fa-laptop',
    image: '',
    description: '',
  }, {
    title: 'Structures/ Values',
    icon: 'fa fa-anchor',
    image: '',
    description: '',
  }, {
    title: 'Business strategy/ model',
    icon: 'fa fa-map',
    image: '',
    description: '',
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/trends/trends/trends.ts